import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { validarTokenInvitacion, getConfiguracionPublica, api } from '../../services/api';


function Register() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const { register } = useAuth();
  const [registroCerrado, setRegistroCerrado] = useState(false);

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    edad: ''
  });
  const [invitacionValida, setInvitacionValida] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [cargandoToken, setCargandoToken] = useState(!!token);

  // Validar token al cargar
	useEffect(() => {
	  const verificarAcceso = async () => {
		try {
		  // 1. Si hay token, validarlo
		  if (token) {
			const response = await validarTokenInvitacion(token);
			setFormData(prev => ({ ...prev, email: response.data.email }));
			setInvitacionValida(true);
		  } else {
			// 2. Si NO hay token, verificar si el registro público está activo
			const configResponse = await getConfiguracionPublica('registro_publico_activo');
			const registroPublico = configResponse.data.valor === 'true';

			if (!registroPublico) {
			  setError('El registro público está cerrado. Necesitas una invitación para registrarte.');
			  setRegistroCerrado(true);
			}
		  }
		} catch (error) {
		  if (token) {
			setError('El token de invitación es inválido o ha expirado');
			setInvitacionValida(false);
		  }
		} finally {
		  setCargandoToken(false);
		}
	  };

	  verificarAcceso();
	}, [token]);
	
	
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (formData.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setLoading(true);

    // Si hay token, lo enviamos en el registro
    const userData = {
      ...formData,
      token: token || undefined
    };

    const result = await register(userData);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  if (cargandoToken) {
    return (
      <div className="auth-container">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div className="loading-spinner"></div>
          <p>Validando invitaci&oacute;n...</p>
        </div>
      </div>
    );
  }
	
if (registroCerrado) {
  return (
    <div className="auth-container">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '20px' }}>🔒</div>
        <h2>Registro cerrado</h2>
        <p className="auth-error">El registro p&uacute;blico est&aacute; cerrado por el momento. Necesitas una invitaci&oacute;n para acceder.</p>
        <Link to="/" className="btn btn-primary">Volver al inicio</Link>
      </div>
    </div>
  );
}

  // Si hay token pero es inválido
  if (token && !invitacionValida) {
    return (
      <div className="auth-container">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '20px' }}>❌</div>
          <h2>Invitaci&oacute;n no v&aacute;lida</h2>
          <p className="auth-error">{error || 'El token ha expirado o no existe'}</p>
          <Link to="/" className="btn btn-primary">Volver al inicio</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
	   <img src="/logo-kreamun.png" alt="KREAMUN" className="auth-logo" />
        <h2>Crear Cuenta</h2>
        <p className="auth-subtitle">
          {token ? 'Completa tu registro como beta tester' : 'Comienza a crear tus universos'}
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre de usuario</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Creador de mundos"
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={!!token} // SOLO LECTURA si viene de invitación
              placeholder="tu@email.com"
              className={token ? 'input-disabled' : ''}
            />
            {token && (
              <small className="email-fixed">
                Este email fue preasignado en tu invitación
              </small>
            )}
          </div>

          <div className="form-group">
            <label>Edad (opcional)</label>
            <input
              type="number"
              name="edad"
              value={formData.edad}
              onChange={handleChange}
              placeholder="25"
            />
          </div>

          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="••••••••"
            />
          </div>

          <div className="form-group">
            <label>Confirmar Contraseña</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="••••••••"
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Creando cuenta...' : 'Registrarse'}
          </button>
        </form>

        {!token && (
          <p className="auth-footer">
            �Ya tienes cuenta? <Link to="/login">Inicia Sesi&oacute;n</Link>
          </p>
        )}
      </div>
    </div>
  );

}
export default Register;